import { Store, STORES } from "./store";
import { AuthData } from "./types";

export class User {
    userId: string;
    name: string;
    company: string;
    email: string;
    photo: string;
    plan: string;
    designation: string;
    createdAt: string;

    constructor(data: AuthData) {
        this.userId = data.uid;
        this.name = data.displayName;
        this.company = data?.company || "";
        this.email = data.email;
        this.photo = data.photoURL;
        this.createdAt = new Date().toISOString();
        this.plan = data?.plan || "Free";
        this.designation = data?.designation || "";
    }
}

export const saveUser = async (data: any) => {
    try {
        const user = await getUser(data.uid);

        if (user?.exists()) return user.data();

        const userdata = new User(data);

        await Store.insertWithID(STORES.USERS, data.uid, { ...userdata });

        return await getProfile(data.uid);
    } catch (error) {
        return null;
    }
};

export const getUser = async (uid: string) => {
    try {
        const result = await Store.findOne(STORES.USERS, uid);

        return result;
    } catch (error) {
        return null;
    }
};

export const getProfile = async (uid: string) => {
    try {
        const result = await Store.findOne(STORES.USERS, uid);

        return result.data();
    } catch (error) {
        return null;
    }
};
